/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, inject, Input } from '@angular/core';

import { AuthenticationFacade } from '@qwyk/portals/authentication';
import { ShipmentTrackingEventsFacade } from '@qwyk/shared-stores/shipment-tracking-events';

@Component({
    selector: 'qwyk-shipment-tracking-events-view',
    templateUrl: './shipment-tracking-events-view.component.html',
    styleUrls: ['./shipment-tracking-events-view.component.scss'],
})
export class ShipmentTrackingEventsViewComponent {

    private readonly auth = inject(AuthenticationFacade);
    private readonly shipmentTrackingEvents = inject(ShipmentTrackingEventsFacade);

    public dateFormat$ = this.auth.dateFormat$;
    public shipmentTrackingEvents$ =
        this.shipmentTrackingEvents.allShipmentTrackingEvents$;
    public loading$ = this.shipmentTrackingEvents.loading$;

    private _shipment: any;
    public get shipment(): any {
        return this._shipment;
    }

    @Input()
    public set shipment(shipment: any) {
        this._shipment = shipment;
        this.shipmentTrackingEvents.init(shipment);
    }
}
